/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_User_Detail_Profile_TitleInputs */

const en_admin_user_detail_profile_title = /** @type {(inputs: Admin_User_Detail_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profile`)
};

const de_admin_user_detail_profile_title = /** @type {(inputs: Admin_User_Detail_Profile_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profil`)
};

/**
* | output |
* | --- |
* | "Profile" |
*
* @param {Admin_User_Detail_Profile_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_user_detail_profile_title = /** @type {((inputs?: Admin_User_Detail_Profile_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_User_Detail_Profile_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_user_detail_profile_title(inputs)
	return en_admin_user_detail_profile_title(inputs)
});